<template>
  <div id="charges" class="wrrapper">
    <page-heading title="Charges">
      <template #content>
        <div class="flex align-center">
          <Button
            className="button--primary mr-1"
            title="Add Charges"
            :onClick="addCharges"
          ></Button>
          <Input
            class="search"
            type="text"
            v-model="searchText"
            placeholder="Search By Name"
          />
          <Select
            v-if="isAdmin"
            class="ml-2"
            styles="expenses-select"
            placeholder="Filter by Branch"
            :input="handleBranchChange"
            :options="brachData"
          />
        </div>
      </template>
    </page-heading>
    <data-table
      :cols="columns"
      :rows="listCharges"
      :options="options"
      height="calc(100vh - 15rem)"
      :loading="loading"
    >
      <template slot="action" slot-scope="{ actions }">
        <dropdown-menu
          :rowData="actions"
          :handleItemClick="handleItems"
          :items="items"
        />
      </template>
    </data-table>
    <modal
      title="Update Charges"
      name="charges"
      class="custom-modal"
      width="600"
      height="510"
      :adaptive="true"
    >
      <template v-slot:content>
        <div class="mt-3">
          <form class="create-service mb-base">
            <Input
              class="mb-base"
              label="Doctor Name"
              type="text"
              v-model="service"
              disabled
            />
            <Input class="mb-base" label="Fee" type="text" v-model="amount" />
            <Select
              label="Service Head"
              :options="servicesList"
              styles="mb-base"
              :input="handleServices"
              :placeholder="currentChargeType"
              :clearable="false"
            />
            <Select
              v-if="isAdmin"
              class="mt-2"
              styles="mb-base"
              label="Select Branch"
              :placeholder="currentSelectedBranch.name"
              :input="handleUpdateBranchChange"
              :options="brachData"
            />
            <Button
              className="button--primary custom-button"
              title="Update Charges"
              :onClick="updateCharges"
            ></Button>
          </form>
        </div>
      </template>
    </modal>
    <Create />
  </div>
</template>

<script>
import DataTable from "@/components/DataTable";
import DropdownMenu from "@/components/DropdownMenu";
import Button from "@/components/Button";
import Modal from "@/components/Modal";
import Input from "@/components/Input";
import Create from "./create";
import { mapActions, mapGetters } from "vuex";
import Select from "../../components/Select.vue";
export default {
  components: {
    DropdownMenu,
    DataTable,
    Button,
    Modal,
    Input,
    Create,
    Select
  },
  data() {
    return {
      brachData: [],
      selectedIdForUpdateCharges: null,
      currentSelectedBranch: { name: "Head Office Branch", key: 1 },
      service: "",
      currentChargeType: "",
      amount: "",
      isAdmin: null,
      searchText: "",
      id: "",
      items: ["Edit", "Delete"],
      columns: [
        { column: "serial", label: "#", width: 60 },
        { column: "name", label: "Doctor Name", sortable: true, sort: true },
        { column: "type", label: "Charge Type", sortable: true },
        { column: "amount", label: "Fee", formatAmount: true, sortable: true },
        {
          column: "branch",
          label: "Branch Name",
          sortable: true
        },
        { column: "action", label: "Action" }
      ],
      options: {
        action: true
      }
    };
  },
  methods: {
    ...mapActions("services", [
      "doctorCharges",
      "editCharge",
      "deleteCharge",
      "filterDoctorChargesByBranch"
    ]),
    ...mapActions("expenses", ["fetchBranch"]),
    ...mapActions("doctors", ["doctorList"]),
    updateCharges() {
      const payload = {
        amount: this.amount,
        type: this.currentChargeType,
        branchId:
          this.selectedIdForUpdateCharges === null
            ? this.currentSelectedBranch.key
            : this.selectedIdForUpdateCharges
      };
      this.editCharge({ id: this.id, payload }).then(() => {
        this.$modal.hide("charges");
        const data = {
          branch:
            this.selectedBranch === null || undefined ? 1 : this.selectedBranch,
          take: 20
        };
        this.filterDoctorChargesByBranch(data);
      });
    },
    handleItems(val, actions) {
      if (val == "Edit") {
        this.$modal.show("charges");
        this.service = actions.name;
        this.amount = actions.amount;
        this.currentChargeType = actions.type;
        this.id = actions.id;
      } else if (val == "Delete") {
        this.deleteCharge(actions.id).then(() => {});
      }
    },
    addCharges() {
      this.$modal.show("chargesAdd");
    },
    handleBranchChange(val) {
      if (val && val != null) {
        this.currentSelectedBranch = val;
        this.selectedBranch = val.key;
        const data = {
          branch: val.key,
          take: 20
          // skip: skip,
        };
        this.filterDoctorChargesByBranch(data);
      }
      if (val === null) {
        this.doctorCharges();
      }
    },
    handleUpdateBranchChange(val) {
      this.selectedIdForUpdateCharges = val.key;
    },
    handleServices(val) {
      this.currentChargeType = val.id;
    }
  },
  computed: {
    ...mapGetters({
      charges: "services/charges",
      loading: "loading",
      user: "auth/userInfo",
      listDoctors: "doctors/listDoctors",
      fetchUserBranch: "expenses/fetchUserBranch"
    }),
    listCharges() {
      const charges = this.charges;
      if (this.searchText) {
        const results = charges.filter(
          item =>
            item.user &&
            item.user.employ &&
            item.user.employ.full_name
              .toLowerCase()
              .indexOf(this.searchText.toLowerCase()) !== -1
        );
        return results.map(item => ({
          id: item.id,
          type: item.lookup && item.lookup.name,
          amount: item.amount,
          name: item.user && item.user.employ && item.user.employ.full_name,
          branch: item && item.branch?.name
        }));
      }
      return charges.map(item => ({
        id: item.id,
        type: item.lookup && item.lookup.name,
        amount: item.amount,
        name: item.user && item.user.employ && item.user.employ.full_name,
        branch: item && item.branch?.name
      }));
    },
    servicesList() {
      return (
        this.listDoctors &&
        this.listDoctors.map(item => ({
          id: item.id,
          name: item.name
        }))
      );
    }
  },
  created() {
    this.isAdmin = this.user.userRole.some(({ name }) => name === "admin");
  },
  async mounted() {
    this.doctorCharges();
    await this.fetchBranch();
    await this.fetchUserBranch.map(elem => {
      this.value = elem.name;
      this.brachData.push({ name: elem.name, key: elem.id });
    });
  }
};
</script>

<style scoped>
/* ── Charges index ─────────────────────────────────────────── */
.create-service {
  display: flex;
  flex-direction: column;
}

/* Full-width submit inside modal forms */
.custom-button {
  width: 100%;
  margin-top: 4px;
}

/* Search input width cap */
.search {
  max-width: 220px;
}
</style>
